// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
  padding: 0.25rem 0;
  font-size: 1.2rem;
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 99999999999999999;
  border-top: 1px solid var(--theme);
  background-color: var(--background);
}

.navbar-container {
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  padding: 0 0.5rem;
}

.navbar-nav-icons {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  padding: 0.25rem 0;
  font-size: 1.75rem;
  text-align: center;
  color: var(--theme);
}

.nav-link-icons {
  color: var(--theme);
  text-decoration: none;
  position: relative;
  opacity: 1;
  transition: color 0.3s ease;
}

.nav-icon-header {
  margin-top: 0.15rem;
  font-size: 1rem;
  line-height: 1;
  color: var(--theme-consistent);
}

.nav-link-icons.selected {
  color: var(--secondary-theme);
  text-shadow: 0px 2px 3px rgba(0, 0, 0, 0.15);
  font-size: 2rem;
}

.swipe-icon-cards {
  height: 5vh;
  width: 45px;
  fill: currentColor;
  stroke: currentColor;
}

.notification-count {
  position: absolute;
  top: -4px;
  right: 10px;
  background-color: var(--theme-consistent);
  border-radius: 50%;
  width: 1.4em;
  height: 1.4em;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.2rem;
  color: #fff;
}

.menu-icon-container {
  position: relative;
}

.menu-icon {
  color: var(--theme);
  font-size: 1.75rem;
  transition: color 0.3s ease;
}

.navbar-nav {
  position: absolute;
  bottom: 100%; /* Position it right above the navbar */
  left: 0;
  right: 0;
  padding: 1rem 0;
  display: none;
  background-color: var(--menu-background);
  border-top: 1px solid var(--theme-consistent);
  transition: transform 0.3s ease;
  transform: translateY(100%); /* Start hidden below the viewport */
}

.navbar-nav.show {
  display: flex;
  flex-direction: column;
  align-items: center;
  transform: translateY(0); /* Slide up to reveal */
}

.nav-link {
  color: var(--theme-consistent);
  text-decoration: none;
  font-size: 1.25rem;
  margin: 0.5rem 0;
  transition: color 0.3s ease;
}

.nav-link:hover,
.nav-link-icons:hover {
  color: var(--secondary-theme);
}

.logout-btn {
  background-color: transparent;
  border: none;
  color: var(--theme-consistent);
  cursor: pointer;
  font-size: 1.25rem;
  padding: 0.25rem;
  transition: color 0.3s ease;
}

.logout-btn:hover {
  color: var(--secondary-theme);
}

.menu-toggle {
  margin-bottom: 1rem;
}

@media only screen and (max-width: 500px) {
  .navbar {
    font-size: 1rem;
  }

  .navbar-container {
    padding: 12px 0.25rem;
  }

  .nav-icon-header {
    font-size: 1rem;
  }

  .menu-icon {
    font-size: 1.5rem;
  }
}

@media only screen and (max-height: 570px) {
  .navbar {
    padding: 0.15rem 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/LoggedInNavbar.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,SAAS;EACT,WAAW;EACX,0BAA0B;EAC1B,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,4CAA4C;EAC5C,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,yCAAyC;EACzC,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,YAAY,EAAE,uCAAuC;EACrD,OAAO;EACP,QAAQ;EACR,eAAe;EACf,aAAa;EACb,wCAAwC;EACxC,6CAA6C;EAC7C,+BAA+B;EAC/B,2BAA2B,EAAE,oCAAoC;AACnE;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,wBAAwB,EAAE,uBAAuB;AACnD;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".navbar {\n  padding: 0.25rem 0;\n  font-size: 1.2rem;\n  position: fixed;\n  bottom: 0;\n  width: 100%;\n  z-index: 99999999999999999;\n  border-top: 1px solid var(--theme);\n  background-color: var(--background);\n}\n\n.navbar-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  width: 100%;\n  padding: 0 0.5rem;\n}\n\n.navbar-nav-icons {\n  display: flex;\n  align-items: center;\n  justify-content: space-evenly;\n  padding: 0.25rem 0;\n  font-size: 1.75rem;\n  text-align: center;\n  color: var(--theme);\n}\n\n.nav-link-icons {\n  color: var(--theme);\n  text-decoration: none;\n  position: relative;\n  opacity: 1;\n  transition: color 0.3s ease;\n}\n\n.nav-icon-header {\n  margin-top: 0.15rem;\n  font-size: 1rem;\n  line-height: 1;\n  color: var(--theme-consistent);\n}\n\n.nav-link-icons.selected {\n  color: var(--secondary-theme);\n  text-shadow: 0px 2px 3px rgba(0, 0, 0, 0.15);\n  font-size: 2rem;\n}\n\n.swipe-icon-cards {\n  height: 5vh;\n  width: 45px;\n  fill: currentColor;\n  stroke: currentColor;\n}\n\n.notification-count {\n  position: absolute;\n  top: -4px;\n  right: 10px;\n  background-color: var(--theme-consistent);\n  border-radius: 50%;\n  width: 1.4em;\n  height: 1.4em;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 1.2rem;\n  color: #fff;\n}\n\n.menu-icon-container {\n  position: relative;\n}\n\n.menu-icon {\n  color: var(--theme);\n  font-size: 1.75rem;\n  transition: color 0.3s ease;\n}\n\n.navbar-nav {\n  position: absolute;\n  bottom: 100%; /* Position it right above the navbar */\n  left: 0;\n  right: 0;\n  padding: 1rem 0;\n  display: none;\n  background-color: var(--menu-background);\n  border-top: 1px solid var(--theme-consistent);\n  transition: transform 0.3s ease;\n  transform: translateY(100%); /* Start hidden below the viewport */\n}\n\n.navbar-nav.show {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  transform: translateY(0); /* Slide up to reveal */\n}\n\n.nav-link {\n  color: var(--theme-consistent);\n  text-decoration: none;\n  font-size: 1.25rem;\n  margin: 0.5rem 0;\n  transition: color 0.3s ease;\n}\n\n.nav-link:hover,\n.nav-link-icons:hover {\n  color: var(--secondary-theme);\n}\n\n.logout-btn {\n  background-color: transparent;\n  border: none;\n  color: var(--theme-consistent);\n  cursor: pointer;\n  font-size: 1.25rem;\n  padding: 0.25rem;\n  transition: color 0.3s ease;\n}\n\n.logout-btn:hover {\n  color: var(--secondary-theme);\n}\n\n.menu-toggle {\n  margin-bottom: 1rem;\n}\n\n@media only screen and (max-width: 500px) {\n  .navbar {\n    font-size: 1rem;\n  }\n\n  .navbar-container {\n    padding: 12px 0.25rem;\n  }\n\n  .nav-icon-header {\n    font-size: 1rem;\n  }\n\n  .menu-icon {\n    font-size: 1.5rem;\n  }\n}\n\n@media only screen and (max-height: 570px) {\n  .navbar {\n    padding: 0.15rem 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
